var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$auth.isAuthenticated)?_c('div',{staticStyle:{"margin-top":"40px","font-weight":"bold"}},[_vm._v(" Bulk Upload Portal ")]):_c('BulkUploadCSV')}
var staticRenderFns = []

export { render, staticRenderFns }